module.exports = __webpack_public_path__ + "7c402beeaca2f82996197715e88fa8f2.svg";